import type { CSSProperties } from 'react';
import type { SxProps, Theme } from '@mui/material/styles';

type PlaceholderPageStyleMap = {
    root: SxProps<Theme>
};

export const placeholderPageStyles: PlaceholderPageStyleMap = {
    root: { textAlign: 'center', py: 8 },
};

export const placeholderWrenchColor = '#bdbdbd';

export const placeholderWrenchStyle: CSSProperties = {
    marginBottom: 16,
};
